var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTopPnLLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.334 39H25.334V43H39.334V39Z",
    fill: "#FAE279"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.334 59V63H17.334V59H19.334H45.334H47.334Z",
    fill: "#CA8600"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.334 43L45.334 59H19.334L20.334 43H25.334H39.334H44.334Z",
    fill: "#CA8600"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.334 47L41.334 55H23.334L24.334 47H40.334Z",
    fill: "#F6DF6D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.334 50H26.334V52H28.334V50Z",
    fill: "#9196AA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.334 50H30.334V52H38.334V50Z",
    fill: "#9196AA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.459 57L19.334 59H45.334L45.209 57H19.459Z",
    fill: "#AF7401"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.334 32H27.334V39H37.334V32Z",
    fill: "#C1B579"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44.334 28V32H37.334H27.334H20.334V28H44.334Z",
    fill: "#F8E8A1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1836 24H46.4836C46.3836 25.33 46.3336 26.66 46.3336 28H18.3336C18.3336 26.66 18.2836 25.33 18.1836 24Z",
    fill: "#E9B44B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3341 1L27.1041 3.86C26.2268 4.62304 25.525 5.56687 25.0469 6.62672C24.5687 7.68656 24.3256 8.83732 24.3341 10C22.6292 8.02436 20.6647 6.2886 18.4941 4.84L22.3341 1Z",
    fill: "#EAB44B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3347 1L46.7747 4.44C44.3709 5.97282 42.2018 7.84558 40.3347 10C40.3443 8.89207 40.1244 7.79415 39.689 6.77532C39.2536 5.75649 38.612 4.8388 37.8047 4.08L38.3347 4L43.3347 1Z",
    fill: "#EAB44B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M46.774 4.44C48.223 3.50042 49.7483 2.68422 51.334 2C48.7686 9.09153 47.1382 16.4871 46.484 24H18.184C17.5298 16.4871 15.8994 9.09153 13.334 2C15.141 2.77926 16.8689 3.73029 18.494 4.84C20.6646 6.2886 22.6291 8.02436 24.334 10C24.3254 8.83732 24.5686 7.68656 25.0467 6.62672C25.5249 5.56687 26.2267 4.62304 27.104 3.86C28.6119 2.52816 30.399 1.55091 32.334 1C34.3751 1.57988 36.2497 2.63541 37.804 4.08C38.6113 4.8388 39.2529 5.75649 39.6883 6.77532C40.1237 7.79415 40.3436 8.89207 40.334 10C42.2011 7.84558 44.3702 5.97282 46.774 4.44Z",
    fill: "#FFE870"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M18.494 9.84C20.2846 11.0563 21.9448 12.4544 23.448 14.012C23.7759 14.0299 24.0941 14.1292 24.374 14.301C24.5392 12.2006 25.5189 10.248 27.104 8.86C28.6119 7.52816 30.399 6.55091 32.334 6C34.3751 6.57988 36.2497 7.63541 37.804 9.08C39.2541 10.4503 40.1427 12.3109 40.297 14.3C40.5766 14.1285 40.8945 14.0291 41.222 14.011C42.8938 12.2822 44.7564 10.7487 46.774 9.44C47.586 8.915 48.48 8.398 49.433 7.906C50.454 4.289 51.334 2 51.334 2C49.7483 2.68422 48.223 3.50042 46.774 4.44C44.3702 5.97282 42.2011 7.84558 40.334 10C40.3436 8.89207 40.1237 7.79415 39.6883 6.77532C39.2529 5.75649 38.6113 4.8388 37.804 4.08C36.2497 2.63541 34.3751 1.57988 32.334 1C30.399 1.55091 28.6119 2.52816 27.104 3.86C26.2267 4.62304 25.5249 5.56687 25.0467 6.62672C24.5686 7.68656 24.3254 8.83732 24.334 10C22.6291 8.02436 20.6646 6.2886 18.494 4.84C16.8689 3.73029 15.141 2.77926 13.334 2C13.334 2 14.214 4.289 15.234 7.907C16.3583 8.48559 17.4469 9.13108 18.494 9.84Z",
    fill: "#FFF2B0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7985 6.64893C49.6805 7.04893 49.5595 7.46193 49.4355 7.89993C49.5595 7.46193 49.6805 7.04593 49.7985 6.64893Z",
    fill: "#FFAC5A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1765 2.427C51.1325 2.548 51.0765 2.696 51.0195 2.866C51.0795 2.7 51.1345 2.547 51.1765 2.427Z",
    fill: "#FFAC5A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4669 4.5C50.3729 4.787 50.2749 5.094 50.1719 5.425C50.2745 5.09633 50.3729 4.788 50.4669 4.5Z",
    fill: "#FFAC5A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1445 5.50903C50.0375 5.85203 49.9275 6.21403 49.8125 6.59803C49.9265 6.21403 50.0335 5.85203 50.1445 5.50903Z",
    fill: "#FFAC5A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2914 2.11108L51.1914 2.38508C51.2334 2.27008 51.2684 2.17408 51.2914 2.11108Z",
    fill: "#FFAC5A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M28.334 50H26.334V52H28.334V50Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M38.334 50H30.334V52H38.334V50Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopPnLLight);
export default __webpack_public_path__ + "static/media/topPnLLight.a04a5978a06f96e24f051382aa7d6f96.svg";
export { ForwardRef as ReactComponent };